/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { HomeStyle } from "./styles";

import { Box, Button } from "@mui/material";
import TemplatePage from "../TemplatePage";
import Headerr from "../../Headerr";

const Access: FC = () => {
  const { t } = useTranslation();
  return (
    <TemplatePage>
      <Box sx={HomeStyle.mainContainer}>
        <Headerr passedData={""} />
        <Box>
          <a
            href="https://arpt.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            style={HomeStyle.arptUrl}
          >
            ARPT
          </a>
        </Box>
        <Box mt={3} display="flex" justifyContent="center">
          <Button variant="contained" color="primary" href="/create-wallet">
            {t('home.createWalletBtn')}
          </Button>
        </Box>
      </Box>
    </TemplatePage>
    
  );
};

export default Access;
